<header>
  <div *ngIf="getRouter().url !== '/'">
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <a class="navbar-brand" href="/home">Portal</a>
        <ul class="navbar-nav" style="margin-left: 20px;">
          <li class="nav-item" style="margin-left: 8px;">
            <a class="nav-link" href="/forms" style="color: aliceblue;">Formularios</a>
          </li>
          <li *ngIf="isAdmin" class="nav-item" style="margin-left: 8px;">
            <a class="nav-link" href="/templates" style="color: aliceblue;">Plantillas</a>
          </li>
          <li *ngIf="isAdmin" class="nav-item" style="margin-left: 8px;">
            <a class="nav-link" href="/users" style="color: aliceblue;">Usuarios</a>
          </li>
          <button class="btn btn-outline-light my-2 my-sm-0" type="submit" (click)="logOut()">Log out</button>
        </ul>
    </div>
  </nav>     
  </div>
</header>
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>
<footer></footer>